var map = {
	"./amazed.png": "acd2",
	"./care.png": "cabc",
	"./celebrate.png": "2748",
	"./cool.png": "ba72",
	"./gradeful.png": "5d24",
	"./happy.png": "d59c",
	"./like.png": "6b16",
	"./love.png": "e35d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "158a";